import ConfirmDialogService from './confirm-dialog';
export default class DiscardChangesService extends ConfirmDialogService {}
